import React from 'react'
import classNames from 'classnames';
import { CONTACTS_BY_COUNTRY } from "~/constants/contacts";
import {useAppSelector} from "~/hooks/redux";

interface IInfo {
  header: string
  description: string
  links: {
    icon?: React.ReactNode
    text: string
    value: string
  }[]
}

interface IInfoData {
  [country: string]: IInfo[];
}

export const ContactsBlock: React.FC = () => {
  const { country } = useAppSelector(state => state.countryReducer);
  const info = getInfo(country?.value);

  const renderLink = (link: { text?: string; value: string; icon: React.ReactNode}) => (
      <a
        key={link.text}
        className='onlinepbx__help__support__link'
        rel='noreferrer'
        target='_blank'
        href={link.value}
      >
        {link.text}
        {link.icon}
      </a>
  )

  return (
    <div className={classNames('onlinepbx__help__support', { 'onlinepbx__help__support__slim': country?.value !== 'RU'})}>
      <div className='onlinepbx__help__support__content'>
        {info.map((col: any, index: any) => (
          <div key={index}
               className={classNames('onlinepbx__help__support__block', { 'onlinepbx__help__support__block__wider': country?.value === 'RU'})}>
            {col.header && <div className='onlinepbx__help__support__header'>{col.header}</div>}
            {col.description && <div  className='onlinepbx__help__support__description'>{col.description}</div>}
            {(col.links || []).map(renderLink)}
          </div>
        ))}
      </div>
    </div>
  )
}

const getInfo = (selectedCountry: string): IInfo[] => {
  const infoData: IInfoData = {
    RU: [
      {
        header: 'Техподдержка',
        description: 'Технические вопросы и помощь в настройке',
        links: CONTACTS_BY_COUNTRY.RU.support.phone
      },
      {
        header: '',
        description: '',
        links: CONTACTS_BY_COUNTRY.RU.support.phoneGroup
      },
      {
        header: '',
        description: '',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.RU.support.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.RU.support.mail}`
          },
          {
            icon: <img src={process.env.PUBLIC_DIR + '/images/telegram-mini.svg'} className='onlinepbx__help__support__icon' />,
            text: CONTACTS_BY_COUNTRY.RU.support.telegram,
            value: `${'https://tlgg.ru/' + CONTACTS_BY_COUNTRY.RU.support.telegram}`
          }
        ]
      },
      {
        header: 'Отдел продаж',
        description: 'Консультация и условия использования',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.RU.sales.phone,
            value: `${'tel:' + CONTACTS_BY_COUNTRY.RU.sales.value}`
          },
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.RU.sales.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.RU.sales.mail}`
          }
        ]
      },
      {
        header: 'Бухгалтерия',
        description: 'Финансовые и юридические вопросы',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.RU.accounting.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.RU.accounting.mail}`
          }
        ]
      },
      {
        header: 'Для партнеров',
        description: 'Вопросы по партнерской программе',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.RU.partners.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.RU.partners.mail}`
          }
        ]
      }
    ],
    UZ: [
      {
        header: 'Техподдержка',
        description: 'Технические вопросы и помощь в настройке',
        links: CONTACTS_BY_COUNTRY.UZ.support.phone
      },
      {
        header: 'Отдел продаж',
        description: 'Консультация и условия использования',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.UZ.sales.phone,
            value: `${'tel:' + CONTACTS_BY_COUNTRY.UZ.sales.value}`
          },
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.UZ.sales.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.UZ.sales.mail}`
          },
          {
            icon: CONTACTS_BY_COUNTRY.UZ.sales.telegram.icon,
            text: CONTACTS_BY_COUNTRY.UZ.sales.telegram.text,
            value: CONTACTS_BY_COUNTRY.UZ.sales.telegram.value
          }
        ]
      },
      {
        header: 'Бухгалтерия',
        description: 'Финансовые и юридические вопросы',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.UZ.accounting.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.UZ.accounting.mail}`
          }
        ]
      },
      {
        header: 'Для партнеров',
        description: 'Вопросы по партнерской программе',
        links: CONTACTS_BY_COUNTRY.UZ.partners.phone
      }
    ],
    KZ: [
      {
        header: 'Техподдержка',
        description: 'Технические вопросы и помощь в настройке',
        links: CONTACTS_BY_COUNTRY.KZ.support.phone
      },
      {
        header: 'Отдел продаж',
        description: 'Консультация и условия использования',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.KZ.sales.phone,
            value: `${'tel:' + CONTACTS_BY_COUNTRY.KZ.sales.value}`
          },
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.KZ.sales.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.KZ.sales.mail}`
          }
        ]
      },
      {
        header: 'Бухгалтерия',
        description: 'Финансовые и юридические вопросы',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.KZ.accounting.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.KZ.accounting.mail}`
          }
        ]
      },
      {
        header: 'Для партнеров',
        description: 'Вопросы по партнерской программе',
        links: [
          {
            icon: <div />,
            text: CONTACTS_BY_COUNTRY.KZ.partners.mail,
            value: `${'mailto:' + CONTACTS_BY_COUNTRY.KZ.partners.mail}`
          }
        ]
      }
    ],
  }

  return infoData[selectedCountry] || [];
}

export default ContactsBlock
